export function getCountdownParts(milliseconds: number) {
  const remaining = Math.max(0, milliseconds);
  return {
    days: Math.floor(remaining / 86_400_000),
    hours: Math.floor((remaining / 3_600_000) % 24),
    minutes: Math.floor((remaining / 60_000) % 60),
    seconds: Math.floor((remaining / 1000) % 60),
  };
}

export function formatCountdown(milliseconds: number, words = false) {
  const { days, hours, minutes, seconds } = getCountdownParts(milliseconds);
  const dayLabel = days === 1 ? "יום אחד" : days === 2 ? "יומיים" : `${days} ימים`;

  if (words) {
    return `${dayLabel}, ${hours} שעות, ${minutes} דקות ו־${seconds} שניות`;
  }

  const time = [hours, minutes, seconds].map((value) => String(value).padStart(2, "0")).join(":");
  return days > 0 ? `${dayLabel} · ${time}` : time;
}
